
export const SEND_CODE_REQUEST = "send_code_request"
export const SEND_CODE_SUCCESS = "send_code_success"
export const SEND_CODE_FAILURE = "send_code_failure"

export const VERIFY_CODE_REQUEST = "verify_code_request"
export const VERIFY_CODE_SUCCESS = "verify_code_success"
export const VERIFY_CODE_FAILURE = "verify_code_failure"

export const REGISTER_USER = "register_user"
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull"
export const REGISTER_USER_FAILED = "register_user_failed"

export const RESET_STAGE = "RESET_STAGE"
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"
